import i18n from "@/lib/i18n";
// CSV + PDF export utilities with BeraStays branding

export function exportToCSV(data: Record<string, any>[], filename: string) {
  if (!data.length) return;
  const headers = Object.keys(data[0]);
  const csvRows = [
    headers.join(","),
    ...data.map(row =>
      headers.map(h => {
        const val = row[h] ?? "";
        const str = String(val).replace(/"/g, '""');
        return `"${str}"`;
      }).join(",")
    ),
  ];
  const blob = new Blob(["\uFEFF" + csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
  downloadBlob(blob, `${filename}.csv`);
}

import { htmlToPdfDownload } from "@/lib/htmlToPdf";

export async function exportToPDF(
  title: string,
  data: Record<string, any>[],
  filename: string,
  options?: { subtitle?: string; columns?: { key: string; label: string }[] }
) {
  if (!data.length) return;

  const columns = options?.columns || Object.keys(data[0]).map(k => ({ key: k, label: k }));
  const docLocale = ({ pt: "pt-AO", en: "en-US", fr: "fr-FR", zh: "zh-CN" } as Record<string, string>)[(i18n.language || "pt").split("-")[0]] || "pt-AO";
  const now = new Date().toLocaleDateString(docLocale, { day: "2-digit", month: "long", year: "numeric" });
  const tagline = i18n.t("export.tagline", { defaultValue: "Plataforma de Hospedagem Premium em Angola" });
  const generatedLabel = i18n.t("export.generatedAt", { defaultValue: "Relatório gerado em" });
  const footer = i18n.t("export.copyrightNotice", { defaultValue: "Documento Financeiro Oficial e Confidencial" });
  const totalRecords = i18n.t("export.totalRecords", { defaultValue: "Total de registos: {{count}}", count: data.length });

  const tableRows = data.map(row =>
    `<tr>${columns.map(c => `<td style="padding:12px 14px;border-bottom:1px solid #f3f4f6;font-size:11px;color:#1f2937;font-weight:500;">${row[c.key] ?? "—"}</td>`).join("")}</tr>`
  ).join("");

  const html = `
    <div style="font-family:'Inter','Helvetica Neue',Arial,sans-serif;padding:32px;color:#1f2937;background:#ffffff;">
      <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:24px;padding-bottom:16px;border-bottom:3px solid #E8513D;">
        <div>
          <h1 style="font-size:24px;font-weight:800;margin:0;color:#E8513D;letter-spacing:-0.02em;">BeraStays</h1>
          <p style="font-size:10px;color:#4b5563;margin:4px 0 0;font-weight:600;text-transform:uppercase;letter-spacing:0.06em;">${tagline}</p>
        </div>
        <div style="text-align:right;">
          <p style="font-size:10px;color:#9ca3af;margin:0;text-transform:uppercase;letter-spacing:0.06em;font-weight:500;">${generatedLabel}</p>
          <p style="font-size:13px;font-weight:700;margin:2px 0 0;color:#1f2937;">${now}</p>
        </div>
      </div>
      <div style="margin-bottom:20px;">
        <h2 style="font-size:17px;font-weight:700;margin:0 0 4px;color:#1f2937;">${title}</h2>
        ${options?.subtitle ? `<p style="font-size:12px;color:#4b5563;margin:0;font-weight:500;">${options.subtitle}</p>` : ''}
      </div>
      <table style="width:100%;border-collapse:collapse;margin-top:12px;">
        <thead>
          <tr style="background:#FFF5F4;border-bottom:2px solid #E8513D;">
            ${columns.map(c => `<th style="padding:12px 14px;text-align:left;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:#E8513D;">${c.label}</th>`).join("")}
          </tr>
        </thead>
        <tbody>${tableRows}</tbody>
      </table>
      <div style="margin-top:32px;padding-top:16px;border-top:1px solid #e5e7eb;display:flex;justify-content:space-between;align-items:center;">
        <p style="font-size:9px;color:#9ca3af;margin:0;font-weight:500;">© ${new Date().getFullYear()} BeraStays — ${footer}</p>
        <p style="font-size:9px;font-weight:700;color:#E8513D;margin:0;text-transform:uppercase;letter-spacing:0.06em;">${totalRecords}</p>
      </div>
    </div>
  `;

  await htmlToPdfDownload(html, filename);
}

function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
